// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1y-o";
export var animationRelative = "_1y-n";
export var backdropBlur = "_1y-0";
export var detailLabelCell = "_1y-10";
export var detailTable = "_1y-z";
export var detailValueCell = "_1y-11";
export var docIconBox = "_1y-19";
export var docTypeRow = "_1y-14";
export var docTypeRowInner = "_1y-15";
export var dropdownMatchDatePicker = "_1y-1";
export var fileUploadSpin = "_1y-h";
export var gorgiasOpenButton = "_1y-13 _1y-b";
export var gorgiasTicketCard = "_1y-12";
export var heroModalFooterButton = "_1y-16";
export var hiddenContainer = "_1y-m";
export var maxWidthContainer = "_1y-17";
export var modalContentBody = "_1y-8";
export var modalHeaderImage = "_1y-3";
export var modalImageLabel = "_1y-5";
export var modalImageOverlay = "_1y-4";
export var modalImageSubtitle = "_1y-7";
export var modalImageTitle = "_1y-6";
export var modalImageWrapper = "_1y-2";
export var modalStickyFooter = "_1y-9";
export var removeButton = "_1y-c";
export var sidebarColumn = "_1y-18";
export var spinner = "_1y-g";
export var timelineLine = "_1y-w";
export var timelineLineBlack = "_1y-y _1y-w";
export var timelineLineGray = "_1y-x _1y-w";
export var timelineLineHeight = "_1y-v";
export var tlDotActivate = "_1y-s";
export var tlDotActivateAnim = "_1y-r";
export var tlDotHide = "_1y-q";
export var tlDotHideAnim = "_1y-p";
export var tlLineActivate = "_1y-u";
export var tlLineActivateAnim = "_1y-t";
export var uploadHint = "_1y-l";
export var uploadIconBox = "_1y-i";
export var uploadLabel = "_1y-k";
export var uploadText = "_1y-j";
export var uploadZone = "_1y-d";
export var uploadZoneCursorDefault = "_1y-f";
export var uploadZoneCursorPointer = "_1y-e";
export var uploadedFileRow = "_1y-a";
export var viewButton = "_1y-b";